import Cookies from "js-cookie";
import { Recipe } from "../models/Recipe";

export function getAllRecipes() {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/recipe';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    }).then(response => {
        return response.ok ? response.json() : [];
    });
}

export function getRecipeById(recipeId: string | undefined) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/recipe/' + recipeId;
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    }).then(response => {
        return response.ok ? response.json() : null;
    });
}

export function saveRecipe(recipe: Recipe) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/recipe';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(recipe)
    }).then(response => {
        return response.ok ? response.json() : null;
    });
}

export function uploadImage(recipeId: number, imageFile: any) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/recipe/' + recipeId + '/image';
    const token: string | undefined = Cookies.get('token');
    const formData: FormData = new FormData();
    formData.append('file', imageFile);

    return fetch(api_path, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        body: formData,
    });
}

export function deleteRecipeById(recipeId: number) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/recipe/' + recipeId;
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        },
    });
}

export function getRecipeImage(recipeId: number) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/recipe/' + recipeId + '/image';
    const token: string | undefined = Cookies.get('token');

    return fetch(api_path, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(response => {
        return response.ok ? response.blob() : null;
    });
}

export function getRecipeThumbnail(recipeId: number) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/recipe/' + recipeId + '/thumbnail';
    const token: string | undefined = Cookies.get('token');

    return fetch(api_path, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(response => {
        return response.ok ? response.blob() : null;
    });
}

export function getAllTags() {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/recipe/tags';
    const token : string | undefined = Cookies.get('token');

    return fetch(api_path, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(response => {
        return response.ok ? response.json() : [];
    });
}

export function addNewTag(recipeId: number, newTag: string) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/recipe/' + recipeId + '/tag/' + newTag;
    const token : string | undefined = Cookies.get('token');

    return fetch(api_path, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
}

export function removeTag(recipeId: number, tag: string) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/recipe/' + recipeId + '/tag/' + tag;
    const token : string | undefined = Cookies.get('token');

    return fetch(api_path, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
}

export function shareRecipe(recipeId: string, username: string) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/recipe/' + recipeId + '/sharedUsers/' + username;
    const token: string | undefined = Cookies.get('token');

    return fetch(api_path, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
}

export function removeSharedUser(recipeId: string, username: string) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/recipe/' + recipeId + '/sharedUsers/' + username;
    const token: string | undefined = Cookies.get('token');

    return fetch(api_path, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
}